import { render } from "./ClosedDepartment.vue?vue&type=template&id=9ba4ecb2"
import script from "./ClosedDepartment.vue?vue&type=script&lang=js"
export * from "./ClosedDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__